module.exports = __webpack_public_path__ + "img/vueaccordian.719b2b58.gif";